import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core'
import { useState } from 'react'
import Api from '../../../Apis/api.service'
import { DynamicViewComponentPAC } from '../../../tickets_common'
import { StatusProgressV2 } from '../../../utils'
import { CustomFileDetailTable } from '../../file_upload'
import TicketDetailDialog from './TicketDetailDialog'
import config from '../../../config'
const publicUrl = config.PUBLIC_URL

const TicketItem = ({ ticket, process, linkable_type, coproprietaire }) => {
  const [file_dialog_data, setFileDialogData] = useState([])
  const [openFileDialog, setOpenFileDialog] = useState(false)
  const [loadingFiles, setLoadingFiles] = useState(false)
  const getFilesTicket = async (id, params) => {
    setLoadingFiles(true)
    const res = await Api.tickets.getFilesExtranetTicket(id, { ...params })
    if (res.status == 200) {
      setFileDialogData(
        res.data.map((item) => {
          return {
            category: item.category,
            preview_document: item.url,
            purpose: item.purpose,
            type: item.type,
            url: item.url,
          }
        })
      )
    }
    setLoadingFiles(false)
  }
  return (
    <div key={ticket.id}>
      <ListItem alignItems="flex-start">
        <ListItemText
          primary={
            <Grid container direction="row" justifyContent="space-between">
              <Grid item>
                <Typography>{`#${ticket.id} ${ticket.libelle}`}</Typography>
              </Grid>
              <Grid item>
                <Grid
                  item
                  style={{
                    marginLeft: 'auto',
                    cursor: 'pointer',
                    backgroundColor: '#143a60',
                    borderRadius: '1rem',
                    padding: '4px',
                    height: '20px',
                    position: 'relative',
                    width: '20px',
                    marginTop: '3px',
                  }}
                >
                  <img
                    src="/img/icons/file-present.svg"
                    style={{
                      width: '12px',
                      position: 'absolute',
                    }}
                    onClick={() => {
                      getFilesTicket(ticket.id, {
                        coproprietaire_id: coproprietaire?.id,
                      })
                      setOpenFileDialog(true)
                    }}
                  />
                </Grid>

                <TicketDetailDialog
                  ticket={ticket}
                  process={process}
                  publicUrl={publicUrl}
                />
              </Grid>
            </Grid>
          }
          secondary={
            <div>
              <StatusProgressV2
                ticket={{ ...ticket, step_rank: ticket.step }}
              />
              <DynamicViewComponentPAC record={ticket} />
            </div>
          }
        />
      </ListItem>
      <Divider />
      <Dialog
        open={openFileDialog}
        onClose={() => {
          setFileDialogData([])
          setOpenFileDialog(false)
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Documents</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid
              item
              // md={8}
              style={{
                marginBottom: '16px',
              }}
            >
              <CustomFileDetailTable hideUrl={true} rows={file_dialog_data} />
            </Grid>
          </Grid>
          <Grid container alignItems="center" justifyContent="center">
            <Grid item style={{ textAlign: 'center' }}>
              <img
                style={{
                  width: '50%',
                }}
                src={`${publicUrl}/img/ext_coprosummary_files.svg`}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default TicketItem
